import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import TimerIcon from "./timer.png";

const SingleOfferActivation = ({
  offer,
  isAttrLoaded,
  client,
  activated,
  singleOfferActivated,
  remainingTime,
  isUnderGap,
  activateOffer,
  tenanturl,
  language,
  tenant,
  isUnlimitedReactivation,
  unlimitedOfferActivated,
  isFinalActivation,
}) => {
  useEffect(() => {
    if (isFinalActivation) {
      // console.log("Final Activation of offer id: ", offer.id);
    }
  }, [isFinalActivation, offer]);

  // Helper function to determine which activation state to render
  const renderActivationState = () => {
    // Single activation cases
    if (activated && singleOfferActivated) {
      return (
        <div
          className="btn btn-success ms-md-2 ms-0 rounded-5 px-4"
          disabled
          style={{
            backgroundColor: "#1ECD6C",
            borderColor: "#1ECD6C",
            fontSize: "14px",
            paddingTop: "0.75rem",
            paddingBottom: "0.7rem",
          }}
        >
          {language?.static_labels.activated}{" "}
        </div>
      );
    }

    if (
      offer.remainingActivations === null &&
      offer.activationExpiry === null &&
      offer.activationStatus === "Not Activated"
    ) {
      return (
        <button
          type="submit"
          variant="primary"
          className="btn btn-secondary ms-md-2 ms-0 rounded-5 px-4"
          onClick={activateOffer}
          style={{
            fontSize: "14px",
            paddingTop: "0.75rem",
            paddingBottom: "0.7rem",
          }}
        >
          <i className="bi bi-wallet2 me-3"></i>
          {language?.static_labels.activate}
        </button>
      );
    }

    if (
      offer.remainingActivations === null &&
      offer.activationExpiry &&
      offer.activationStatus === "Activated"
    ) {
      return (
        <div className="d-flex align-items-start flex-column flex-md-row">
          {renderExpiryTimer()}
          <div
            className="btn btn-success ms-md-2 ms-0  rounded-5 px-4"
            disabled
            style={{
              backgroundColor: "#1ECD6C",
              borderColor: "#1ECD6C",
              fontSize: "14px",
              paddingTop: "0.75rem",
              paddingBottom: "0.7rem",
            }}
          >
            {language?.static_labels.activated}{" "}
          </div>
        </div>
      );
    }

    if (
      !offer.remainingActivations &&
      !offer.activationExpiry &&
      offer.activationStatus === "Activated"
    ) {
      return (
        <div
          className="btn btn-success ms-md-2 ms-0  rounded-5 px-4"
          disabled
          style={{
            backgroundColor: "#1ECD6C",
            borderColor: "#1ECD6C",
            fontSize: "14px",
            paddingTop: "0.75rem",
            paddingBottom: "0.7rem",
          }}
        >
          {language?.static_labels.activated}{" "}
        </div>
      );
    }

    if (
      !offer.remainingActivations &&
      !offer.activationExpiry &&
      offer.activationStatus === "Not Activated"
    ) {
      return (
        <button
          type="submit"
          variant="primary"
          className="btn btn-secondary ms-md-2 ms-0 rounded-5 px-4"
          onClick={activateOffer}
          style={{
            fontSize: "14px",
            paddingTop: "0.75rem",
            paddingBottom: "0.7rem",
          }}
        >
          <i className="bi bi-wallet2 me-3"></i>
          {language?.static_labels.activate}
        </button>
      );
    }

    if (
      (activated &&
        offer.activationExpiry &&
        offer.remainingActivations === 0) ||
      (activated &&
        offer.activationExpiry &&
        offer.remainingActivations === 0 &&
        offer.activationStatus === "Activated")
    ) {
      return (
        <div className="d-flex align-items-start flex-column flex-md-row">
          {renderExpiryTimer()}
          <div
            className="btn btn-success ms-md-2 ms-0  rounded-5 px-4"
            disabled
            style={{
              backgroundColor: "#1ECD6C",
              borderColor: "#1ECD6C",
              fontSize: "14px",
              paddingTop: "0.75rem",
              paddingBottom: "0.7rem",
            }}
          >
            {language?.static_labels.activated}{" "}
          </div>
        </div>
      );
    }

    if (activated && isUnlimitedReactivation) {
      return (
        <div className="d-flex align-items-start flex-column flex-md-row">
          {renderExpiryTimer()}
          <div
            className="btn btn-success ms-md-2 ms-0 rounded-5 px-4"
            disabled
            style={{
              backgroundColor: "#1ECD6C",
              borderColor: "#1ECD6C",
              fontSize: "14px",
              paddingTop: "0.75rem",
              paddingBottom: "0.7rem",
            }}
          >
            {language?.static_labels.activated}{" "}
          </div>
        </div>
      );
    }

    //testing0001

    if (activated && offer.activationExpiry && offer.remainingActivations) {
      return (
        <div className="d-flex align-items-start flex-column flex-md-row">
          {renderExpiryTimer()}
          <div
            className="btn btn-success ms-md-2 ms-0 rounded-5 px-4"
            disabled
            style={{
              backgroundColor: "#1ECD6C",
              borderColor: "#1ECD6C",
              fontSize: "14px",
              paddingTop: "0.75rem",
              paddingBottom: "0.7rem",
            }}
          >
            {language?.static_labels.activated}{" "}
          </div>
        </div>
      );
    }

    if (
      offer.activationExpiry &&
      offer.remainingActivations === null &&
      offer.activationStatus === "Activated"
    ) {
      return (
        <div className="d-flex align-items-start flex-column flex-md-row">
          {renderExpiryTimer()}
          <div
            className="btn btn-success ms-md-2 ms-0  rounded-5 px-4"
            disabled
            style={{
              backgroundColor: "#1ECD6C",
              borderColor: "#1ECD6C",
              fontSize: "14px",
              paddingTop: "0.75rem",
              paddingBottom: "0.7rem",
            }}
          >
            {language?.static_labels.activated}{" "}
          </div>
        </div>
      );
    }

    if (!offer.activationExpiry && offer.remainingActivations && activated) {
      return (
        <div className="d-flex align-items-start flex-column flex-md-row">
          {renderExpiryTimer()}
          <div
            className="btn btn-success ms-md-2 ms-0  rounded-5 px-4"
            disabled
            style={{
              backgroundColor: "#1ECD6C",
              borderColor: "#1ECD6C",
              fontSize: "14px",
              paddingTop: "0.75rem",
              paddingBottom: "0.7rem",
            }}
          >
            {language?.static_labels.activated}{" "}
          </div>
        </div>
      );
    }

    // Not activated conditions
    if (!activated) {
      if (
        (!offer.remainingActivations &&
          !offer.activationExpiry &&
          offer.activationStatus === "Not Activated") ||
        (offer.remainingActivations &&
          !offer.activationExpiry &&
          offer.activationStatus === "Not Activated")
      ) {
        return (
          <button
            type="submit"
            variant="primary"
            className="btn btn-secondary ms-md-2 ms-0 rounded-5 px-4"
            onClick={activateOffer}
            style={{
              fontSize: "14px",
              paddingTop: "0.75rem",
              paddingBottom: "0.7rem",
            }}
          >
            <i className="bi bi-wallet2 me-3"></i>
            {language?.static_labels.activate}
          </button>
        );
      }
      if (!activated && isUnlimitedReactivation) {
        return (
          <div className="d-flex align-items-start flex-column flex-md-row">
            {isUnderGap && remainingTime && renderReactivationTimer()}
            <button
              type="submit"
              variant="primary"
              disabled={isUnderGap}
              className="btn btn-secondary ms-md-2 ms-0 rounded-5 px-4"
              onClick={activateOffer}
              style={{
                fontSize: "14px",
                paddingTop: "0.75rem",
                paddingBottom: "0.7rem",
              }}
            >
              <i className="bi bi-wallet2 me-3"></i>
              {language?.static_labels.activate}
            </button>
          </div>
        );
      }

      if (!offer.remainingActivations || offer.remainingActivations > 0) {
        return (
          <div className="d-flex align-items-start flex-column flex-md-row">
            {isUnderGap && remainingTime && renderReactivationTimer()}
            <button
              type="submit"
              variant="primary"
              disabled={isUnderGap}
              className="btn btn-secondary ms-md-2 ms-0 rounded-5 px-4"
              onClick={activateOffer}
              style={{
                fontSize: "14px",
                paddingTop: "0.75rem",
                paddingBottom: "0.7rem",
              }}
            >
              <i className="bi bi-wallet2 me-3"></i>
              {language?.static_labels.activate}
            </button>
          </div>
        );
      }
    }

    return null;
  };

  // Helper component for expiry timer
  const renderExpiryTimer = () => (
    <div>
      <div
        className="d-flex align-items-center border border-primary rounded-pill bg-white ps-2 pe-3 md-mb-0 "
        style={{
          maxWidth: "fit-content",
          paddingTop: "0.2rem",
          paddingBottom: "0.2rem",
          marginBottom: "0.5rem",
        }}
      >
        <img
          src={TimerIcon}
          alt="Timer"
          className="me-2"
          style={{ width: "30px", height: "30px" }}
        />
        <div className="d-flex flex-column text-primary">
          <span
            className="small"
            style={{ fontSize: "12px", fontWeight: "600" }}
          >
            {language?.static_labels.activation_expire_in}
          </span>
          <span
            className="fw-medium"
            style={{ fontSize: "13px", fontWeight: "600" }}
          >
            {remainingTime}
          </span>
        </div>
      </div>
    </div>
  );

  // Helper component for reactivation timer
  const renderReactivationTimer = () => (
    <div>
      <div
        className="d-flex align-items-center border border-primary rounded-pill bg-white ps-2 pe-3 md-mb-0 "
        style={{
          maxWidth: "fit-content",
          paddingTop: "0.2rem",
          paddingBottom: "0.2rem",
          marginBottom: "0.5rem",
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/timer.png`}
          alt="Timer"
          className="me-2"
          style={{ width: "30px", height: "30px" }}
        />
        <div className="d-flex flex-column text-primary">
          <span
            className="small"
            style={{ fontSize: "12px", fontWeight: "600" }}
          >
            {language?.static_labels.reactivate_in}
          </span>
          <span
            className="fw-medium"
            style={{ fontSize: "13px", fontWeight: "600" }}
          >
            {remainingTime}
          </span>
        </div>
      </div>
    </div>
  );

  if (!offer.activationRequired) {
    return tenant?.tenantmasterconfig?.time_bound.show_view ? (
      <div className="px-3">
        <Link
          className="btn btn-primary text-decoration-none w-100 rounded-pill"
          to={`/${tenanturl}/offerdetail/${offer.id}`}
        >
          {language?.static_labels.view_detail}
        </Link>
      </div>
    ) : null;
  }

  if (!isAttrLoaded) {
    return null;
  }

  if (!client) {
    return (
      <div className="px-3">
        <Link
          className="btn btn-secondary text-decoration-none w-100 rounded-pill"
          to={`/${tenanturl}/signin`}
        >
          {language?.static_labels.signin_to_activate}
        </Link>
      </div>
    );
  }

  return renderActivationState();
};

export default SingleOfferActivation;
